<template>
  <form @submit.prevent="updateQty" method="POST">
    <input type="hidden" name="action" value="commerce/cart/updateLineItem">
    <input type="hidden" name="redirect" value="shop/cart">
    <input type="hidden" hidden="purchasableId" :value="itemid">
    <input type="hidden" :name="$root.$options.csrf.name" :value="$root.$options.csrf.value">

    <qty-input
      :item-qty="itemqty"
      :show-label="false"
      ref="qtyInput"
      @qty-update="updateQty"></qty-input>
  </form>
</template>

<script>
import axios from "axios"
import { EventBus } from "../../lib/event-bus.js"
import QtyInput from "./QtyInput.vue"

export default {
  props: {
    itemid: {
      required: true
    },
    itemqty: {
      default: 1
    }
  },

  components: {
    QtyInput
  },

  methods: {
    updateQty(qty) {
      // use URLSearchParams to format data as application/x-www-form-urlencoded for Craft2
      let params = new URLSearchParams();
      params.append(this.$root.$options.csrf.name, this.$root.$options.csrf.value);
      params.append('action', 'commerce/cart/updateLineItem');
      params.append('lineItemId', this.itemid);
      params.append('qty', qty || this.$refs.qtyInput.qty);

      axios({
        method: 'post',
        url: '/',
        data: params,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
       .then((response) => {
         EventBus.$emit('qty-update');
         //console.log('success');
       })
      .catch((error) => {
        console.log('Qty Form Error:', error);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/QtyForm.vue